<template>
  <div>
    <v-btn
      @click="onVtn(0, init, tag(rule))"
      :disabled="data.Records[0].disabled"
      block
      :style="'font-size:20px;letter-spacing:30px;'"
      :color="colorString"
      height="50"
    >
      {{ label }}
    </v-btn>
  </div>
</template>

<script>
export default {
  /*
   */
  props: {
    record: Object,
    label: String,
    init: String,
    rows: Number,
    rule: String,
    color: String,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [
          { value: this.init, form_id: 0, form_type: 8, disabled: false },
        ],
      },
    };
  },
  async mounted() {
    this.data.Records[0].value = this.init;
    //
    let rules = this.rule.split(",");
    if (rules[4] == "true" && rules[6] == "on") {
      this.data.Records[0].disabled = true;
    }
  },
  computed: {
    colorString: function() {
      let tmp = this.color.split(",");
      let tmp2 = "";
      tmp.forEach((v) => {
        tmp2 += " " + v;
      });
      return tmp2;
    },
  },
  methods: {
    onVtn(index, value, tag) {
      if (tag == "time") {
        this.data.Records[index].value = this.getDateTime();
      } else if (tag == "form") {
        //value = form index
        this.data.Records[index].value = this.data.Records[value].value;
      } else {
        this.data.Records[index].value = value;
      }
      let rules = this.rule.split(",");
      if (rules[1] != "") {
        this.data.Records[index].disabled = true;
      }
      if (rules[4] == "true") {
        alert("プレビュー画面なので、ボタン連動は未実装です");
      }
    },
    getDateTime() {
      let date = new Date();
      let years = date.getFullYear().toString();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let days = date
        .getDate()
        .toString()
        .padStart(2, "0");
      let hours = date
        .getHours()
        .toString()
        .padStart(2, "0");
      let minutes = date
        .getMinutes()
        .toString()
        .padStart(2, "0");
      let seconds = date
        .getSeconds()
        .toString()
        .padStart(2, "0");
      return (
        years +
        "-" +
        month +
        "-" +
        days +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    //
    tag() {
      const p = this.rule;
      switch (p) {
        case "0":
          return "time";
        case "1":
          return "time";
        case "2":
          return "time";
      }
    },
  },
};
</script>

<style>
@import "../../../../../css/styles.css";
</style>
